import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Icon, Breadcrumb } from '@softwaredev_cegeka/stix-core'
import { reverse } from 'src/routes/config'
import './crumbs.scss'

class Crumbs extends Component {
    render() {
        const {
            match: { params },
            breadcrumbs,
        } = this.props
        let items = []
        if (breadcrumbs instanceof Function) {
            items = breadcrumbs(params)
        } else if (Array.isArray(breadcrumbs)) {
            items = breadcrumbs
        }
        return (
            <Breadcrumb customSeparator>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
                    <Icon icon="home" />
                </Breadcrumb.Item>
                {items.map((item, index) =>
                    item.linkName ? (
                        <Breadcrumb.Item
                            active={index === items.length - 1}
                            key={index}
                            linkAs={Link}
                            linkProps={{ to: reverse(item.linkName, params) }}
                        >
                            {item.label}
                        </Breadcrumb.Item>
                    ) : (
                        <Breadcrumb.Item active key={index}>
                            {item.label}
                        </Breadcrumb.Item>
                    )
                )}
            </Breadcrumb>
        )
    }
}

export default Crumbs
